import { render, staticRenderFns } from "./AddAllocaDialog.vue?vue&type=template&id=cf1323f2&scoped=true"
import script from "./AddAllocaDialog.vue?vue&type=script&lang=js"
export * from "./AddAllocaDialog.vue?vue&type=script&lang=js"
import style0 from "./AddAllocaDialog.vue?vue&type=style&index=0&id=cf1323f2&prod&lang=scss&scoped=true"
import style1 from "./AddAllocaDialog.vue?vue&type=style&index=1&id=cf1323f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1323f2",
  null
  
)

export default component.exports